import axios from "axios"
import { i18n } from "@/plugins/i18n"
import { MessageBox } from "element-ui"
import { notification } from "@/utils/utils"

/**
 *
 * DOC
 *
 * il file contiene  anionee delot
 *
 * subito soto, la definizione dell'array di impostazione per il css come costante
 *
 *  */

const BASESETTINGS = {
	sfondo: "#FFF",
	padding: "20px 20px 20px 20px",
	width: "auto",
	height: "auto",
	align: "center"
}
export default {
	namespaced: true,
	state: {
		/**
		 * DOC
		 * lista deggli elementi draggabili,
		 * la struttura di ogni elemento si compone di:
		 * -name= nome visualizzato
		 *-id= id univoco della riga, viene comunque randomizzato sul drag, quindi è sufficiente che sia univoso su questo array
		 * -hasChildren= numero di colonne figlie dell'elemento. se 0, l'elemento non ha colonne figlie, altrimenti tante quante il numero
		 * -items= array opzionale da mettere solo se hasChildren è diverso da 0, normalmente è vuoto ma puù anche contentere altre righe all'occorrenza
		 * -value= valore di default dell'elemento, normalmente "" o 0
		 * -type= tipologia dell'elemento. per essere valuida deve essere dichiarata e associata a un componente partendo da reflect-component.vue e seguendo la gerarchia
		 * setting= opzionale, contiene l'array delle proprietà css, default a BASESETTINGS
		 *
		 *
		 * AGGIORNAMENTO
		 *
		 * la lista viene caricata da backend, la sostanza non cambia
		 *
		 * */
		list: [
			// { name: "casella di testo", id: 0, hasChildren: 0, value: "", type: "text", setting:BASESETTINGS },
			//
			// { name: "numero", id: 1, hasChildren: 0, value: "", type: "number", setting: BASESETTINGS },
			// { name: "titolo", id: 3, hasChildren: 0, value: "", type: "h1", setting:BASESETTINGS },
			// { name: "sottotitolo", id: 4, hasChildren: 0, value: "", type: "h2", setting: BASESETTINGS },
			// { name: "sotto-sottotitolo", id: 5, hasChildren: 0, value: "", type: "h3" , setting:BASESETTINGS },
			// { name: "immagine", id: 6, hasChildren: 0, value: "", type: "img", setting:BASESETTINGS },
			// { name: "Dipendente", id: 105, hasChildren: 0, value: "", type: "empl", setting: BASESETTINGS },
			// { name: "2 colonne", id: 99, items: [], hasChildren: 2, type: 'row', setting: BASESETTINGS },
			// { name: "4 colonne", id: 104, items: [], hasChildren: 4, type: 'row', setting: BASESETTINGS },
			// { name: "3 colonne", id: 100, items: [], hasChildren: 3, type: 'row', setting: BASESETTINGS },
			// { name: "centrato", id: 101, items: [], hasChildren: 1, type: 'align-center', setting: BASESETTINGS },
			// { name: "sinistra", id: 102, items: [], hasChildren: 1, type: 'align-left', setting: BASESETTINGS },
			// { name: "destra", id: 103, items: [], hasChildren: 1, type: 'align-right', setting: BASESETTINGS },
			// { name: "editor di testo", id: 106, hasChildren: 0, value: "", type: "editor", setting:BASESETTINGS },
		],
		listSaved: [],
		listDeleted: [],
		toinsert: {},
		showInsert: false,
		showEdit: false,
		editElement: {
			setting: BASESETTINGS
		},
		selectOptions: [
			{
				value: "center",
				label: i18n.t("centered")
			},
			{
				value: "flex-start",
				label: i18n.t("left")
			},
			{
				value: "flex-end",
				label: i18n.t("right")
			}
		],
		cutted: undefined
	},
	getters: {
		list: state => state.list,
		listSaved: state => state.listSaved,
		listDeleted: state => state.listDeleted,
		toinsert: state => state.toinsert,
		showInsert: state => state.showInsert,
		showEdit: state => state.showEdit,
		toedit: state => state.editElement,
		selectOptions: state => state.selectOptions,
		cut: state => state.cutted
	},
	mutations: {
		SET_CUT(state, payload) {
			state.cutted = payload
		},
		RESET_CUT(state) {
			state.cutted = undefined
		},
		RESET_LISTS(state) {
			state.list = []
			state.listSaved = []
			state.listDeleted = []
		},
		PUSH_LIST(state, payload) {
			state.list.push(payload)
		},
		PUSH_LIST_SAVED(state, payload) {
			state.listSaved.push(payload)
		},
		PUSH_LIST_DELETED(state, payload) {
			state.listDeleted.push(payload)
		},
		DEL_LIST_SAVED(state, payload) {
			var indx = state.listSaved.findIndex(i => i.ref_id == payload)
			state.listSaved.splice(indx, 1)
		},
		PUSH(state, payload) {
			state.listSaved.push(state.toinsert)
			state.toinsert = {}
		},
		EDIT_INSERT(state, payload) {
			state.toinsert = payload
		},
		SHOW_MODAL(state) {
			state.showInsert = true
		},
		HIDE_MODAL(state) {
			state.showInsert = false
			state.toinsert = {}
		},
		SHOW_EDIT(state) {
			state.showEdit = true
		},
		HIDE_EDIT(state) {
			state.showEdit = false
			state.editElement = {
				setting: BASESETTINGS
			}
		},
		EDIT_EDIT(state, payload) {
			if (payload.hasChildren > 1) {
				if (!payload.setting.column_width) {
					payload.setting.column_width = []
					for (var i = 1; i <= payload.hasChildren; i++) {
						payload.setting.column_width.push(Number((100 / payload.hasChildren).toFixed(1)))
					}
				}
			}

			state.editElement = payload
		}
	},
	actions: {
		setCut({ commit, state }, data) {
			commit("SET_CUT", data)

			return true
		},
		resetCut({ commit, state }) {
			commit("RESET_CUT")

			return true
		},
		addElement({ commit, state }) {
			var element = state.toinsert
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/blocks/saveBlock",
					{ element: element },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					if (res.data.status == "ok") {
						element.ref_id = res.data.id

						commit("PUSH_LIST_SAVED", element)
						notification("success", i18n.t("saved-element-generic"), "")
						return true
					}
				})
				.catch(err => notification("error", i18n.t("save-error"), err))
			return element.ref_id
		},
		async deleteCustomEL({ commit, state }, id) {
			return await MessageBox.confirm(i18n.t("are-u-sure-deleting-saved-block"), i18n.t("warning"), {
				confirmButtonText: "OK",
				cancelButtonText: i18n.t("cancel"),
				type: "error"
			})
				.then(async () => {
					return await axios
						.delete(process.env.VUE_APP_API_URL + "/api/blocks/delBlock/" + id, {
							headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
						})
						.then(async res => {
							if (res.data.status === "ok") {
								commit("DEL_LIST_SAVED", id)
								notification("success", i18n.t("deleted-successfully"), "")
								return true
							}
						})
						.catch(err => {
							notification("error", i18n.t("save-error"), "")
							return false
						})
				})
				.catch(err => {
					return false
				})
		},
		editInsert({ commit }, payload) {
			commit("EDIT_INSERT", payload)
		},
		showModalInsert({ commit }) {
			commit("SHOW_MODAL")
		},
		hideModalInsert({ commit }) {
			commit("HIDE_MODAL")
		},
		editEdit({ commit }, payload) {
			commit("EDIT_EDIT", payload)
		},
		showModalEdit({ commit }) {
			commit("SHOW_EDIT")
		},
		hideModalEdit({ commit }) {
			commit("HIDE_EDIT")
		},
		loadList({ commit }) {
			commit("RESET_LISTS")
			axios
				.get(process.env.VUE_APP_API_URL + "/api/blocks/getDefaultBlocks", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					res.data.blocks.forEach(el => {
						commit("PUSH_LIST", el.json)
					})
					return true
				})
				.catch(err => console.error(err))
			axios
				.get(process.env.VUE_APP_API_URL + "/api/blocks/getSavedBlocks", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					res.data.blocks.forEach(el => {
						el.json.ref_id = el.ref_id
						el.json.deleted = null
						el.json.name = el.name
						el.json.wiki = el.wiki
						commit("PUSH_LIST_SAVED", el.json)
					})
					return true
				})
				.catch(err => console.error(err))
			axios
				.get(process.env.VUE_APP_API_URL + "/api/blocks/getDeletedBlocks", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					res.data.blocks.forEach(el => {
						el.json.ref_id = el.ref_id
						el.json.deleted = el.deleted_at
						el.json.name = el.name
						el.json.wiki = el.wiki
						commit("PUSH_LIST_DELETED", el.json)
					})
				})
				.catch(err => console.error(err))
		}
	}
}
